import { createAction, props } from "@ngrx/store";
import { AccountItemState } from "./models";

export default {
  accountsLoading: createAction("[Account] loading"),
  accountsLoaded: createAction("[Account] accounts loaded successfully", props<{ accounts: AccountItemState[] }>()),
  reset: createAction("[Account] reseted"),
  error: createAction("[Account] error", props<{ error: string }>())
};
